import {
  faDownload,
  faEye,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import Download_offcanvas from "../../../../../../../common/common_offcanvas/download_offcanvas/Download_offcanvas";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import QualityManual_view_offcanvas from "../qualityManual_view_offcanvas/QualityManual_view_offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function QualityManual_table() {
  const [view, setView] = useState(false);
  const [showDownload, setDownload] = useState(false);
  const [showDelete, setDelete] = useState(false);

  /* ================= TABLE DATA ================= */
  const data = [
    {
      srNo: 101,
      documentName: "Document Name 1",
      attachedFile: "Metrological Traceability1001.PDF",
      remarks: "---",
    },
  ];

  /* ================= DELETE HANDLER ================= */
  const handleDelete = () => {
    console.log("Record deleted");
    setDelete(false);
  };
   const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Document Name</th>
                  <th>
                   Attached File
                  </th>
                  <th>
                   Remarks
                  </th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.srNo}</td>

                    {/* Document Name */}
                    <td>{row.documentName}</td>

                    {/* Attached File */}
                    <td>{row.attachedFile}</td>

                    {/* Remarks */}
                    <td>{row.remarks}</td>

                    {/* Action Icons */}
                    <td>
                      <div className="action_icons">
                        <FontAwesomeIcon
                          icon={faEye}
                          title="View"
                          onClick={() => setView(true)}
                        />
                        <FontAwesomeIcon
                          icon={faDownload}
                          title="Download"
                          onClick={() => setDownload(true)}
                        />
                        <FontAwesomeIcon
                          icon={faTrashCan}
                          title="Delete"
                          onClick={() => setDelete(true)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      </section>

      {/* ================= VIEW ================= */}
      <QualityManual_view_offcanvas
        show={view}
        handleClose={() => setView(false)}
      />

      {/* ================= DOWNLOAD ================= */}
      <Download_offcanvas
        show={showDownload}
        handleClose={() => setDownload(false)}
        offcanvasHeading="Download Quality Manual"
        massageText={"Quality Manual"}
      />

      {/* ================= DELETE ================= */}
      <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading=" Delete Quality Manual"
        massageText={"Quality Manual"}
      />
    </>
  );
}

export default QualityManual_table;
